import { ReactNode, useId } from 'react';
import './EmptyState.css';

interface EmptyStateProps {
  icon: ReactNode;
  title: string;
  description: string;
  eyebrow?: string;
  announce?: boolean;
  headingLevel?: 1 | 2;
  className?: string;
  children?: ReactNode;
}

const EmptyState = ({
  icon,
  title,
  description,
  eyebrow,
  announce = false,
  headingLevel = 1,
  className,
  children
}: EmptyStateProps) => {
  const titleId = useId();
  const descriptionId = useId();
  const Heading = headingLevel === 1 ? 'h1' : 'h2';

  return (
    <section
      className={['app-empty-state', className].filter(Boolean).join(' ')}
      aria-labelledby={titleId}
      aria-describedby={descriptionId}
      aria-live={announce ? 'polite' : undefined}
    >
      {eyebrow && <span className="app-empty-state-eyebrow">{eyebrow}</span>}
      <span className="app-empty-state-icon" aria-hidden="true">{icon}</span>
      <div className="app-empty-state-copy">
        <Heading id={titleId}>{title}</Heading>
        <p id={descriptionId}>{description}</p>
      </div>
      {children && <div className="app-empty-state-actions">{children}</div>}
    </section>
  );
};

export default EmptyState;
